import { render, staticRenderFns } from "./PurchaseProcessSection.vue?vue&type=template&id=294edd3b&scoped=true"
import script from "./PurchaseProcessSection.vue?vue&type=script&lang=js"
export * from "./PurchaseProcessSection.vue?vue&type=script&lang=js"
import style0 from "./PurchaseProcessSection.vue?vue&type=style&index=0&id=294edd3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294edd3b",
  null
  
)

export default component.exports